import * as types from '../../actions/actionTypes';
import base64 from 'base-64';

// Initial state
const defaultState = {
  readme: null,
  summary: null,
  commits: null,
};

// Reducer
export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case types.GET_README_SUCCESS:
      let readme = action.data;
      if (readme) readme = base64.decode(readme.content);
      return { ...state, readme };
    case types.GET_SUMMARY_SUCCESS:
      let summary = action.data;
      return { ...state, summary };
    case types.GET_COMMITS_SUCCESS:
      return { ...state, commits: action.data };
    default:
      return nextState;
  }
};
